import React from 'react';
import { useSelector } from 'react-redux';

import { OnboardingWizardStep } from '../../../../types';
import './OnboardingWizardStepsSection.scss';

function getStepParams(step) {
  switch (step) {
    case OnboardingWizardStep.profile:
      return { stepTitle: 'Let’s get started!' };
    case OnboardingWizardStep.workspaces:
      return { stepTitle: 'Create Workspaces' };
    case OnboardingWizardStep.discussionTopics:
      return { stepTitle: 'Add Discussion Topics' };
    case OnboardingWizardStep.discussionTopicsForInvited:
      return { stepTitle: 'Add Discussion Topics' };
    case OnboardingWizardStep.connectCalendar:
      return { stepTitle: 'Connect Calendar' };
    case OnboardingWizardStep.workspacesFromCalendar:
      return { stepTitle: 'Create Workspaces' };
    case OnboardingWizardStep.kudos:
      return { stepTitle: 'Give Kudos' };
    case OnboardingWizardStep.managerAssistantSettings:
      return { stepTitle: 'Meet Manager Assistant' };
    case OnboardingWizardStep.createAccount:
      return { stepTitle: 'Almost there!' };
    default:
      return { stepTitle: 'Let’s get started!' };
  }
}

function OnboardingWizardStepsSection() {
  const step: OnboardingWizardStep = useSelector(state => state.onboardingState.step);
  const numSteps: number = useSelector(state => state.onboardingState.numSteps);
  const stepIndex: number = useSelector(state => state.onboardingState.stepIndex);

  const { stepTitle } = getStepParams(step);

  return (
    <div className="onboarding-wizard-steps-section align-self-lg-end d-flex flex-column">
      <h2 className="mb-0 onboarding-wizard-steps-section-title">{stepTitle}</h2>
      <div className="onboarding-wizard-steps-section-label align-self-end mr-2">
        Step {stepIndex} of {numSteps}
      </div>
      <div className="onboarding-wizard-steps-section-level-line w-100 mb-1">
        <div className="onboarding-wizard-steps-section-level-line-wrapper">
          <div
            className="onboarding-wizard-steps-section-level-line--current-level"
            style={{ width: `${(stepIndex / numSteps) * 103}%` }}
          />
        </div>
      </div>
    </div>
  );
}

export default OnboardingWizardStepsSection;
